import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: true
})
export class FooterComponent {
  year = new Date().getFullYear();
  buildDate = new Date().toISOString().slice(0, 10); // later you can inject real build time
}
